'use client'

import { useEffect } from 'react'

/**
 * WorkspaceBrandPaletteClient
 *
 * Injeta CSS variables --color-brand-* no client-side baseado em hostname.
 * Funciona MESMO se SSR root layout não conseguiu detectar workspace
 * (alguns paths de Next.js 15 cacheiam layout).
 *
 * Injetado uma única vez no <head> via createElement.
 */

const PALETTES: Record<string, {
  primary: string
  primaryLight: string
  c50: string
  c100: string
  c400: string
  c500: string
  c700: string
}> = {
  'patyshiatsu.com.br': {
    primary:      '#8B4789',
    primaryLight: '#B85AB2',
    c50:          '#F4EAF3',
    c100:         '#E2C9DF',
    c400:         '#B85AB2',
    c500:         '#8B4789',
    c700:         '#6E3669',
  },
  'funilchatbot.com.br': {
    primary:      '#0CCE6B',
    primaryLight: '#3EE188',
    c50:          '#E7FBEF',
    c100:         '#C7F4D6',
    c400:         '#3EE188',
    c500:         '#0CCE6B',
    c700:         '#0A9D52',
  },
}

export function WorkspaceBrandPalette() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    const host = window.location.hostname.toLowerCase()
    const matchKey = Object.keys(PALETTES).find((k) => host.endsWith(k))
    if (!matchKey) return
    const palette = PALETTES[matchKey]

    const css = `
      :root {
        --color-brand-50:  ${palette.c50};
        --color-brand-100: ${palette.c100};
        --color-brand-400: ${palette.c400};
        --color-brand-500: ${palette.c500};
        --color-brand-600: ${palette.c500};
        --color-brand-700: ${palette.c700};
        --brand-pink-1:    ${palette.primary};
        --brand-pink-2:    ${palette.primaryLight};
        --brand-grad:      linear-gradient(135deg, ${palette.primary} 0%, ${palette.primaryLight} 100%);
      }
    `

    const style = document.createElement('style')
    style.setAttribute('data-workspace-brand', matchKey)
    style.textContent = css
    document.head.appendChild(style)

    return () => {
      style.remove()
    }
  }, [])

  return null
}
